import http from 'services/http';

export const loginGuestUser = async ({
  phone,
  organization,
  captcha,
  rewardEligibilityToken
}) => {

  const data = {
    phone, organization, captcha_value: captcha, is_app: false
  }
  if (rewardEligibilityToken) {
    data.reward_eligibility_token = rewardEligibilityToken;
  }

  return http.post('v2/user/customer/auth/login', data).then((res) => res?.data?.data)
};

export const deprecatedUpdateProfile = async (params) => http.post('v1/user/profile/', params).then((res) => res.data);
export const updateProfile = async (params) => http.patch('v1/user/profile/', params).then((res) => res.data);
export const sendOTP = async ({ code, token }) => http.post('v1/user/otp', { code, token }).then((res) => res.data);
